<p-card
  [title]="largeComponentContentBanner().content.headline"
  class="large-presentation flex h-full w-full"
  styleClass="noBorder"
  [class.card-max-width]="!isResponsive()">
  <div class="flex flex-column align-items-start justify-content-start w-full">
    <ng-template pTemplate="header">
      @if (largeComponentContentBanner().content.image) {
        <ppg-image
          [url]="largeImgUrl()"
          [height]="largeImgHeight()"
          [width]="largeImgWidth()"
          [description]="largeImgDescription()"
          class="w-full" />
      }
    </ng-template>
    @if (largeComponentContentBanner().content.image) {
      <ppg-image
        [url]="largeImgUrl()"
        [height]="largeImgHeight()"
        [width]="largeImgWidth()"
        [description]="largeImgDescription()"
        class="w-full" />
    }
    <div class="vertical-content-banner-body">
      @if (largeComponentContentBanner().content.showLogo) {
        <div class="logo">
          <img [ngSrc]="logo()" alt="PPG Logo" width="58" height="46" />
        </div>
      }
      <ppg-content-banner-headline
        [headline]="largeComponentContentBanner().content.headline"></ppg-content-banner-headline>
      <ppg-content-banner-subheading
        [subheading]="largeComponentContentBanner().content.subheading"></ppg-content-banner-subheading>
      <div>
        @for (contentItem of largeComponentContentBanner().content.content; track $index) {
          <ppg-rich-text class="description" [content]="contentItem.content"></ppg-rich-text>
        }
      </div>
      @if (largePresentationContentBannerCta()) {
        <ppg-container-content-banner-cta [cta]="largePresentationContentBannerCta()" />
      }
    </div>
  </div>
</p-card>
